module.exports = __webpack_public_path__ + "img/burkina-faso.2db515f3.png";